import { RealTimeConnectionStatus } from './server-communication-status';
import { IceCandidateDto } from '../../../generated/signalR/ice-candidate-dto';
import { WebRtcSdpOfferRemoteDto } from '../../../generated/signalR/web-rtc-sdp-offer-remote-dto';
import { RealTimeConnectionStatusChangedRealTimeData } from '../../../generated/signalR/real-time-connection-status-changed-real-time-data';
import { UserSystemMonitoringChangedRealTimeData } from '../../../generated/signalR/user-system-monitoring-changed-real-time-data';
import { ConnectionInfo } from '../../../generated/signalR/connection-info';
import { SamwinLogonErrorReceivedRealTimeData } from '../../../generated/signalR/samwin-logon-error-received-real-time-data';
import { WebRtcIceServerRealTimeData } from 'src/generated/signalR/web-rtc-ice-server-real-time-data';

export class ConnectSignalR {
   public static readonly type = '[ServerCommunication] Connect SignalR';
}

export class ReconnectSignalR {
   public static readonly type = '[ServerCommunication] Reconnect SignalR';
}

export class DisconnectSignalR {
   public static readonly type = '[ServerCommunication] Disconnect SignalR';
}

export class RealTimeConnectionStatusChanged {
   public static readonly type = '[ServerCommunication] real time connection status changed';

   constructor(public realTimeConnectionStatusData: RealTimeConnectionStatusChangedRealTimeData) {}
}

export class StartHttpLoading {
   public static readonly type = '[ServerCommunication] Start Http Loading';
}

export class FinishHttpLoading {
   public static readonly type = '[ServerCommunication] Finish Http Loading';
}

export class RealTimeConnectorStatusChanged {
   public static readonly type = '[ServerCommunication] SignalR Connector Status changed';

   constructor(public newConnectionState: RealTimeConnectionStatus, public sessionIdUsedForSignalR?: string, public connectionInfo?: ConnectionInfo) {}
}

export class WebRtcStartClientEndpoint {
   public static readonly type = '[ServerCommunication] Web Rtc Start Client Endpoint';

   constructor(public callInitiatorId: string, public iceServers: WebRtcIceServerRealTimeData[]) {}
}

export class WebRtcSdpSignalingAdded {
   public static readonly type = '[ServerCommunication] Web Rtc Sdp Signaling Added';

   constructor(public sdpOffer: WebRtcSdpOfferRemoteDto) {}
}

export class WebRtcIceCandidatesAddedByServer {
   public static readonly type = '[ServerCommunication] Web Rtc Ice Candidates Added by Server';

   constructor(public iceCandidates: IceCandidateDto[]) {}
}

export class WebRtcIceCandidatesAddedByBrowser {
   public static readonly type = '[ServerCommunication] Web Rtc Ice Candidates Added by Browser';

   constructor(public iceCandidates: IceCandidateDto[]) {}
}

export class WebRtcNegotiationNeeded {
   public static readonly type = '[ServerCommunication] Web Rtc Negotiation Needed';

   constructor() {}
}

export class WebRtcCloseConnection {
   public static readonly type = '[ServerCommunication] Web Rtc Close Connection';
}

export class UserSystemMonitorDataChanged {
   public static readonly type = '[ServerCommunication] user system monitor data changed';

   constructor(public data: UserSystemMonitoringChangedRealTimeData) {}
}

export class SamwinLogonErrorOccurred {
   public static readonly type = '[ServerCommunication] samwin logon error occurred';

   constructor(public data: SamwinLogonErrorReceivedRealTimeData) {}
}
